module.exports = __webpack_public_path__ + "img/case-bj1.2633f2c3.png";